// extracted by mini-css-extract-plugin
export default {"root":"tweet-skeleton_root__E6w-Q"};